
import Home from './components/Home'
import NotFound from './components/NotFound'

const routes = [
  { path: '/track/:searchKey*', component: Home },
  { path: '*', component: NotFound }
];

export default routes;
